import TableCustomized from "../../../common/components/TableCustomized";
import PaperCustomized from "../../../common/components/PaperCustomized";
import { formattedDateTimeFromDB } from "../../../common/utils/FunctionsUtils";

function ListTracMinistere(props) {
  const columns = [
    {
      field: "decision",
      headerName: "Décision",
      flex: 0.75,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "departement",
      headerName: "Département",
      flex: 1,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "numVisa",
      headerName: "N° du visa",
      flex: 0.75,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dateDecision",
      headerName: "Date de la décision",
      flex: 0.75,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "commentaire",
      headerName: "Commentaire",
      flex: 1.25,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
  ];
  const rows = [];
  props?.detail?.tracabiliteMinistere?.map((row, index) => {
    rows.push({
      id: row.id,
      decision: row.decisionMCE?.description,
      departement: row.departement?.description,
      numVisa: row.numDecision,
      dateDecision: formattedDateTimeFromDB(row.dateDecision),
      commentaire: row.observations,
    });
  });
  return (
    <PaperCustomized title={"Traçabilité du Ministère"} forActions={false}>
      <TableCustomized
        columns={columns}
        rows={rows}
        totalElements={rows.length}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationMode="client"
        isSlots={false}
        isFooter={true}
        noDataHeight="120px"
        cursor="auto"
      />
    </PaperCustomized>
  );
}

export default ListTracMinistere;
